// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zp11","label":"styles_label__2r8sG"};